(() => {
  if (customElements.get('raith-shell')) return;

  function nativeReturnTo(form, endpoint, resetPage = true) {
    const fields = form.querySelectorAll('input[type="hidden"][name="return_to"]');
    if (form.method !== 'post' || fields.length !== 1 || fields[0].disabled) return null;
    try {
      const current = new URL(window.location.href), action = new URL(form.action, current);
      const target = new URL(fields[0].value, current.origin);
      if (action.origin !== current.origin || !action.pathname.replace(/\/$/, '').endsWith(endpoint) ||
          target.origin !== current.origin || target.pathname !== current.pathname) return null;
      const search = /\/search\/?$/.test(target.pathname);
      const collection = /\/collections\/[^/]+\/?$/.test(target.pathname);
      const product = /\/products\/[^/]+\/?$/.test(target.pathname);
      const themeId = String(window.Shopify?.theme?.id || '');
      const currentDraft = window.Shopify?.shop === 'raithclothing.myshopify.com' &&
        /^[1-9]\d*$/.test(themeId) && window.Shopify.theme.role === 'unpublished';
      const trustedDraftHost = current.protocol === 'https:' && !current.port &&
        (['raith-clo.com', 'www.raith-clo.com', 'nl.raith-clo.com', 'raithclothing.myshopify.com'].includes(current.hostname) ||
         /^[a-z0-9]+-26611592\.shopifypreview\.com$/.test(current.hostname));
      const carryDraftPreview = endpoint === '/localization' && currentDraft && trustedDraftHost &&
        !window.Shopify.designMode && window.top === window.self;
      target.search = ''; target.hash = '';
      for (const [key, value] of current.searchParams) {
        const searchOption = search && ['q', 'type', 'options[prefix]', 'options[unavailable_products]'].includes(key);
        const facet = (search || collection) && (key === 'sort_by' || /^filter\.[pvmt]\.[a-zA-Z0-9_.-]+$/.test(key));
        const variant = product && key === 'variant' && /^[1-9]\d*$/.test(value);
        const page = !resetPage && (search || collection) && key === 'page' && /^[1-9]\d*$/.test(value);
        const preview = key === 'preview_theme_id' && currentDraft && value === themeId &&
          (endpoint !== '/localization' || carryDraftPreview);
        if (searchOption || facet || variant || page || preview) target.searchParams.append(key, value);
      }
      if (carryDraftPreview) target.searchParams.set('preview_theme_id', themeId);
      return { field: fields[0], value: target.pathname + target.search };
    } catch { return null; }
  }

  // Keep native selection context; Shopify owns the country/language POST.
  document.addEventListener('submit', event => {
    if (!event.target?.matches?.('form.vl-shell-localization')) return;
    const result = nativeReturnTo(event.target, '/localization');
    if (result) result.field.value = result.value;
  }, { capture: true });

  function reconcilePreviewCurrency() {
    const current = new URL(window.location.href);
    if (current.protocol !== 'https:' || current.port || !/^[a-z0-9]+-26611592\.shopifypreview\.com$/.test(current.hostname) ||
        window.Shopify?.shop !== 'raithclothing.myshopify.com' || !/^[1-9]\d*$/.test(String(window.Shopify?.theme?.id)) ||
        window.Shopify.theme.role !== 'unpublished' || window.Shopify.designMode || window.top !== window.self) return;
    const blocks = document.querySelectorAll('[data-raith-preview-currency]');
    if (blocks.length !== 1) return;
    const block = blocks[0], form = block.querySelector('form');
    const { country, expectedCurrency, cartCurrency } = block.dataset;
    if (!form || !/^[A-Z]{2}$/.test(country || '') || !/^[A-Z]{3}$/.test(expectedCurrency || '') ||
        !/^[A-Z]{3}$/.test(cartCurrency || '')) return;
    let action;
    try { action = new URL(form.action, current); } catch { return; }
    if (action.search || action.hash || [...form.elements].some(control => control.name &&
        (!['form_type', 'utf8', 'currency', 'return_to'].includes(control.name) || control.disabled ||
         control.tagName !== 'INPUT' || control.type !== 'hidden'))) return;
    const utf8 = form.querySelectorAll('input[name="utf8"]');
    if (utf8.length > 1 || (utf8.length === 1 && utf8[0].value !== '✓')) return;
    const currency = form.querySelectorAll('input[name="currency"]');
    const kind = form.querySelectorAll('input[name="form_type"]');
    const result = nativeReturnTo(form, '/cart/update', false);
    if (!result || currency.length !== 1 || currency[0].value !== expectedCurrency || currency[0].disabled ||
        kind.length !== 1 || kind[0].value !== 'currency') return;
    const key = 'raith.preview.currency';
    const signature = `${country}:${cartCurrency}:${expectedCurrency}`;
    if (cartCurrency === expectedCurrency) {
      try { sessionStorage.removeItem(key); } catch { /* The page already has its native currency. */ }
      return;
    }
    result.field.value = result.value;
    const retry = () => { block.hidden = false; };
    try {
      if (sessionStorage.getItem(key) === signature) { retry(); return; }
      sessionStorage.setItem(key, signature);
      if (sessionStorage.getItem(key) !== signature) { retry(); return; }
    } catch { retry(); return; }
    try {
      // The documented currency form keeps this cart intact. The bridge only
      // runs where the visitor-preview localization response left it stale.
      HTMLFormElement.prototype.submit.call(form);
    } catch { retry(); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reconcilePreviewCurrency, { once: true });
  else reconcilePreviewCurrency();

  const menuStateKey = 'raithMenuCurrent';
  const menuIntentKey = 'raith.menu.pending';
  const menuRoute = value => {
    try {
      const url = new URL(value, window.location.href);
      return url.origin === window.location.origin ? url.pathname.replace(/\/$/, '') || '/' : null;
    } catch { return null; }
  };
  const menuLinkKey = link => JSON.stringify([menuRoute(link.href), link.textContent.trim().replace(/\s+/g, ' ')]);
  function takeMenuIntent() {
    try {
      const raw = sessionStorage.getItem(menuIntentKey);
      sessionStorage.removeItem(menuIntentKey);
      const intent = JSON.parse(raw);
      const age = Date.now() - intent?.time;
      return Number.isFinite(age) && age >= 0 && age <= 30000 && intent.route === menuRoute(window.location.href) && typeof intent.key === 'string' ? intent : null;
    } catch { return null; }
  }

  // Attentive owns the iframe and signup flow. Mark only its compact teaser so
  // CSS can keep it clear of shopping controls without changing provider state.
  const promoOwners = new Set();
  let stopPromoObserver;
  function observePromo() {
    let frame;
    const selector = '#attentive_overlay iframe#attentive_creative';
    const marker = 'data-vl-promo-compact';
    const pixels = value => /^\d+(?:\.\d+)?px$/.test(value) ? Number.parseFloat(value) : 0;
    const classify = () => {
      if (!frame) return;
      let verified = false;
      try {
        const url = new URL(frame.getAttribute('src'), document.baseURI);
        verified = url.protocol === 'https:' && url.hostname === 'creatives.attn.tv' && url.pathname === '/creatives-dynamic/multiPage/index.html';
      } catch { /* Unknown creatives retain their provider presentation. */ }
      const width = pixels(frame.style.width), height = pixels(frame.style.height);
      const compact = verified && frame.isConnected && frame.matches(selector) && frame.style.position === 'fixed' && width > 0 && width <= 360 && height > 0 && height <= 96;
      if (frame.hasAttribute(marker) !== compact) frame.toggleAttribute(marker, compact);
    };
    const attributes = new MutationObserver(classify);
    const bind = () => {
      const next = document.querySelector(selector);
      if (next !== frame) {
        attributes.disconnect();
        frame?.removeAttribute(marker);
        frame = next;
        if (frame) attributes.observe(frame, { attributes: true, attributeFilter: ['style', 'src', 'id'] });
      }
      classify();
    };
    const structure = new MutationObserver(records => {
      // Watch insertion/removal only globally; provider style changes are
      // observed on this one iframe, with no scroll or layout measurements.
      const relevant = records.some(record => record.target.closest?.('#attentive_overlay') || [...record.addedNodes, ...record.removedNodes].some(node =>
        node.nodeType === 1 && (node.id === 'attentive_overlay' || node.querySelector('#attentive_overlay') || (frame && node.contains(frame)))
      ));
      if (relevant) bind();
    });
    structure.observe(document.body, { childList: true, subtree: true });
    bind();
    return () => { structure.disconnect(); attributes.disconnect(); frame?.removeAttribute(marker); frame = null; };
  }

  class RaithShell extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      promoOwners.add(this);
      if (!stopPromoObserver) stopPromoObserver = observePromo();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.header = this.querySelector('.vl-shell-header');
      this.dialogs = [...this.querySelectorAll('.vl-shell-dialog')];
      const intent = takeMenuIntent();
      const restoringHistory = window.performance.getEntriesByType?.('navigation')[0]?.type === 'back_forward';
      this.syncMenuCurrent(restoringHistory ? null : intent, restoringHistory);
      this.addEventListener('click', event => this.onClick(event), { signal });
      this.addEventListener('keydown', event => this.onKeydown(event), { signal });
      this.addEventListener('submit', event => {
        // Shopify owns the localization POST. Clear our modal before navigation,
        // including same-market submissions and pages restored from back/forward.
        if (event.target.matches('form.vl-shell-localization')) this.close(false);
      }, { signal });
      this.dialogs.forEach(dialog => {
        dialog.addEventListener('cancel', event => {
          event.preventDefault();
          this.close();
        }, { signal });
        dialog.addEventListener('close', () => {
          if (this.activeDialog === dialog && !dialog.open) {
            this.release();
            this.updateHeader();
          }
        }, { signal });
        dialog.addEventListener('pointerdown', event => {
          this.backdropPressed = event.target === dialog;
        }, { signal });
      });
      document.addEventListener('dialog:before-show', () => {
        this.close(false);
        this.updateHeader(true);
      }, { capture: true, signal });
      document.addEventListener('dialog:after-hide', () => this.updateHeader(), { capture: true, signal });
      document.addEventListener('click', event => {
        if (event.target.closest?.('[aria-controls="cart-drawer"]')) this.close(false);
      }, { capture: true, signal });
      this.addEventListener('shopify:block:select', event => {
        if (event.target.closest('.vl-shell-menu__feature')) this.open(this.dialogs[0], this.querySelector('[data-shell-open]'));
      }, { signal });
      const sectionWrapper = this.closest('.shopify-section') || this;
      sectionWrapper.addEventListener('shopify:section:deselect', () => this.close(), { signal });
      window.addEventListener('scroll', () => this.updateHeader(), { passive: true, signal });
      window.addEventListener('pagehide', () => this.close(false), { signal });
      window.addEventListener('pageshow', () => {
        this.close(false);
        // Native facets can replace history.state with {}. A BFCache restore
        // still has this document's selected alias; use it if the entry lost it.
        this.syncMenuCurrent();
        this.updateHeader();
      }, { signal });
      window.addEventListener('popstate', () => this.syncMenuCurrent(null, true), { signal });
      this.observer = new MutationObserver(records => {
        if (!records.some(record => record.attributeName === 'open')) return;
        const otherDialog = [...document.querySelectorAll('[open][role="dialog"]')].find(dialog => !this.dialogs.includes(dialog));
        if (otherDialog || (this.activeDialog && !this.activeDialog.open)) this.close(false);
        this.updateHeader();
      });
      this.observer.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
      const count = this.querySelector('cart-count');
      if (count) {
        const updateCountVisibility = () => count.toggleAttribute('data-empty', count.textContent.trim() === '0');
        this.countObserver = new MutationObserver(updateCountVisibility);
        this.countObserver.observe(count, { childList: true, characterData: true, subtree: true });
        updateCountVisibility();
      }
      this.close(false);
    }

    disconnectedCallback() {
      this.close(false);
      this.controller?.abort();
      this.observer?.disconnect();
      this.countObserver?.disconnect();
      promoOwners.delete(this);
      if (!promoOwners.size) { stopPromoObserver?.(); stopPromoObserver = null; }
    }

    updateHeader(forceSolid = false) {
      const modalOpen = document.querySelector('[open][role="dialog"]');
      this.header?.classList.toggle('is-solid', forceSolid || this.dataset.tone === 'solid' || window.scrollY > 20 || Boolean(modalOpen));
    }

    syncMenuCurrent(intent = null, historyOnly = false) {
      const route = menuRoute(window.location.href);
      const remembered = [intent, window.history.state?.[menuStateKey], !historyOnly && this.menuCurrent]
        .find(record => record?.route === route && typeof record.key === 'string');
      let chosen;
      this.querySelectorAll('.vl-shell-menu').forEach(nav => {
        const links = [...nav.querySelectorAll('a[href]')];
        const matches = links.filter(link => menuRoute(link.href) === route && !link.getAttribute('href').startsWith('#'));
        const current = matches.find(link => menuLinkKey(link) === (chosen || remembered)?.key) ||
          matches.find(link => !link.parentElement.querySelector(':scope > .vl-shell-menu__branch')) || matches[0];
        links.forEach(link => {
          if (link === current) link.setAttribute('aria-current', 'page');
          else link.removeAttribute('aria-current');
        });
        if (current && !chosen) chosen = { route, key: menuLinkKey(current) };
      });
      this.menuCurrent = chosen || null;
      if (!chosen) return;
      const state = window.history.state;
      // Preserve other consumers' state; unfamiliar primitive/array state is
      // left intact rather than coerced into a new object.
      if (state !== null && Object.prototype.toString.call(state) !== '[object Object]') return;
      if (state?.[menuStateKey]?.route === chosen.route && state?.[menuStateKey]?.key === chosen.key) return;
      try { window.history.replaceState({ ...state, [menuStateKey]: chosen }, ''); } catch { /* Navigation remains native when history is unavailable. */ }
    }

    rememberMenuChoice(event) {
      const link = event.target.closest('.vl-shell-menu a[href]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ||
          link.hasAttribute('download') || (link.target && link.target.toLowerCase() !== '_self') || link.getAttribute('href').startsWith('#')) return;
      const route = menuRoute(link.href);
      if (!route) return;
      // A one-use, short-lived intent crosses the native page navigation. The
      // outgoing history entry keeps its previous selection for Back/Forward.
      try { sessionStorage.setItem(menuIntentKey, JSON.stringify({ route, key: menuLinkKey(link), time: Date.now() })); } catch { /* Storage-blocked sessions use the deterministic fallback. */ }
    }

    onClick(event) {
      this.rememberMenuChoice(event);
      const opener = event.target.closest('[data-shell-open]');
      if (opener && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
        const dialog = this.dialogs.find(item => item.id === opener.dataset.shellOpen);
        if (!dialog || typeof dialog.showModal !== 'function') return;
        if (document.querySelector('[open][role="dialog"]:not(.vl-shell-dialog)')) return;
        event.preventDefault();
        this.open(dialog, opener);
        return;
      }
      if (event.target.closest('[data-shell-close]')) this.close();
      else if (event.target === this.activeDialog && this.backdropPressed) this.close();
      else if (this.activeDialog && event.target.closest('a[href]')) this.close(false);
      this.backdropPressed = false;
    }

    open(dialog, opener) {
      this.syncMenuCurrent();
      document.querySelectorAll('raith-shell').forEach(shell => { if (shell !== this) shell.close(false); });
      if (this.activeDialog === dialog) return;
      this.close(false);
      this.opener = opener;
      this.activeDialog = dialog;
      dialog.querySelectorAll('.vl-shell-menu__branch[data-shell-default-open]').forEach(branch => { branch.open = true; });
      dialog.showModal();
      document.documentElement.classList.add('vl-shell-lock');
      opener?.setAttribute('aria-expanded', 'true');
      const locale = opener?.hasAttribute('data-shell-localization-open') && dialog.querySelector('.vl-shell-locale');
      if (locale) {
        locale.open = true;
        (locale.querySelector('select') || locale.querySelector('summary'))?.focus({ preventScroll: true });
        const content = dialog.querySelector('.vl-shell-drawer__content');
        if (content) content.scrollTop += locale.getBoundingClientRect().top - content.getBoundingClientRect().top;
      } else {
        (dialog.querySelector('[data-shell-initial-focus]') || dialog.querySelector('button, a[href]'))?.focus({ preventScroll: true });
      }
      this.updateHeader();
    }

    close(restoreFocus = true) {
      const opener = this.opener;
      // An open native dialog can outlive the tracked reference after navigation
      // or an editor reconnect. Close every dialog owned by this shell only.
      this.dialogs?.forEach(dialog => { if (dialog.open) dialog.close(); });
      this.release();
      if (restoreFocus && opener?.isConnected) opener.focus({ preventScroll: true });
      this.updateHeader();
    }

    release() {
      this.opener?.setAttribute('aria-expanded', 'false');
      this.querySelectorAll('[data-shell-open][aria-expanded="true"]').forEach(opener => opener.setAttribute('aria-expanded', 'false'));
      this.dialogs?.forEach(dialog => {
        dialog.querySelectorAll('[data-shell-disclosure][open]').forEach(details => { details.open = false; });
        const content = dialog.querySelector('.vl-shell-drawer__content');
        if (content) content.scrollTop = 0;
      });
      this.activeDialog = null;
      this.opener = null;
      this.backdropPressed = false;
      if (!document.querySelector('raith-shell .vl-shell-dialog[open]')) {
        document.documentElement.classList.remove('vl-shell-lock');
      }
    }

    onKeydown(event) {
      if (event.key === 'Escape' && this.activeDialog && !event.isComposing) {
        event.preventDefault();
        event.stopPropagation();
        const disclosure = event.target.closest('[data-shell-disclosure][open]');
        if (disclosure && this.activeDialog.contains(disclosure)) {
          disclosure.open = false;
          disclosure.querySelector(':scope > summary')?.focus({ preventScroll: true });
        } else this.close();
        return;
      }
      if (event.key !== 'Tab' || !this.activeDialog) return;
      const focusable = [...this.activeDialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])')]
        .filter(element => element.getClientRects().length && !element.closest('[inert]'));
      const first = focusable[0];
      const last = focusable.at(-1);
      if (!first) { event.preventDefault(); return; }
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  }

  customElements.define('raith-shell', RaithShell);
})();

